const topics = [
  {
    tag: '重磅盘点',
    title: '2026上半年娱乐圈塌房事件全记录',
    desc: '从顶流到十八线，谁都没能逃过这一波。本文完整梳理今年上半年所有轰动娱乐圈的塌房事件，包括时间线、关键人物和后续发展。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20entertainment%20industry%20concept%20with%20broken%20spotlight%20and%20fallen%20stars%2C%20crimson%20and%20black%20color%20scheme%2C%20cinematic%20editorial%20photography%2C%20moody%20atmosphere&width=800&height=450&seq=carousel-01-91hl&orientation=landscape',
    count: '37件',
  },
  {
    tag: '深度揭秘',
    title: '网红圈潜规则：从签约到达人背后的灰色产业链',
    desc: '深入调查网红经纪公司的运作模式，揭开MCN机构与平台之间的利益博弈，以及网红们不为人知的生存现状与幕后交易。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20behind%20the%20scenes%20of%20social%20media%20influencer%20industry%2C%20shadowy%20corporate%20office%2C%20dramatic%20lighting%2C%20cinematic%20style&width=800&height=450&seq=carousel-02-91hl&orientation=landscape',
    count: '深度',
  },
  {
    tag: '独家调查',
    title: '选秀节目投票造假：你以为的民选其实都是剧本',
    desc: '多位前选秀节目工作人员匿名爆料，揭露投票系统背后令人震惊的造假机制。从票数操控到选手内定，整个产业链触目惊心。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20voting%20booth%20with%20dramatic%20shadows%2C%20manipulation%20concept%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20crimson%20accents&width=800&height=450&seq=carousel-03-91hl&orientation=landscape',
    count: '内幕',
  },
  {
    tag: '年度专题',
    title: '明星代言翻车档案：那些年被品牌连夜撤下的面孔',
    desc: '整理近三年所有因负面新闻被品牌方解约的明星代言案例，分析塌房背后的共同特征及品牌危机公关的应对策略与成本。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20advertisement%20billboard%20with%20torn%20poster%2C%20dramatic%20night%20city%20scene%2C%20moody%20atmosphere%2C%20cinematic%20editorial%20style%2C%20crimson%20accents&width=800&height=450&seq=carousel-04-91hl&orientation=landscape',
    count: '28位',
  },
  {
    tag: '资本解密',
    title: '娱乐圈资本局：谁在背后操控你看到的八卦热搜',
    desc: '从微博热搜到短视频推荐，娱乐圈的每一条热搜背后都有资本的影子。本文揭秘热搜产业链的运作方式及背后的利益格局。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20financial%20power%20concept%20with%20glowing%20data%20streams%2C%20mysterious%20corporate%20control%2C%20dramatic%20crimson%20and%20black%20tones%2C%20cinematic%20style&width=800&height=450&seq=carousel-05-91hl&orientation=landscape',
    count: '揭秘',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            🎯 焦点专题
          </h2>
          <p className="text-sm text-foreground-600">
            深度策划的独家专题报道，聚焦最受关注的话题事件
          </p>
        </div>
        <div className="flex flex-nowrap gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-6 scrollbar-thin">
          {topics.map((topic, idx) => (
            <article
              key={idx}
              className="flex-shrink-0 w-[320px] md:w-[380px] bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden bg-background-100">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-accent-950">
                  {topic.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-3 py-1 rounded-full text-xs font-bold bg-black/50 text-white backdrop-blur-sm">
                  {topic.count}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                  {topic.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {topic.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}